import './apple_map.css';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

export const AppleMap = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => {
        return {
            addAnnotation: addAnnotation,
            removeAnnotation: removeAnnotation,
            deleteAllAnotations: deleteAllAnotations,
            geoCoder: geoCoder,
            centerToCoordinates: centerToCoordinates,
            deleteAllOverlays,
            drawCircle,
            drawPoly,
            drawPolyText,
            addAnnotationTracked,
        };
    });

    //STATES
    const [map, setMap] = useState(null);

    //FUNCTIONS
    function deleteAllOverlays() {
        if (map === null) {
            setTimeout(() => {
                deleteAllOverlays();
            }, 50);
            return;
        }
    
        map._impl.removeOverlays(map._impl.overlays);
    }

    function drawCircle(color, radius, latitude, longitude) {
        if (map === null) {
            setTimeout(() => {
                drawCircle(color, radius);
            }, 100);
            return;
        }

        if (color[0] !== "#") {
            color = "#" + color;
        }

        let style = new window.mapkit.Style({
            lineWidth: 2,
            strokeColor: color,
            fillColor: color,
        });

        let coordinates = new window.mapkit.Coordinate(latitude, longitude);
        let circle = new window.mapkit.CircleOverlay(coordinates, parseFloat(radius) * 1609);
        circle.style = style;

        map._impl.addOverlay(circle);
    }

    function drawPolyText(color, pointsText)
    {
        let coords = pointsText.split(',');
        let final = [];

        for (let i = 0; i < coords.length; i++)
        {
            final.push({
                lat: parseFloat(coords[i].split(" ")[0]),
                long: parseFloat(coords[i].split(" ")[1]),
            });
        }

        let points = [];

        for (let i = 0; i < final.length; i++)
        {
            points.push([final[i].lat, final[i].long]);
        }

        points = points.map(function(point) {
            return new window.mapkit.Coordinate(point[0], point[1]);
        });

        drawPoly(color, points);
    }

    function drawPoly(color, points) {
        if (color[0] !== "#") {
            color = "#" + color;
        }

        let style = new window.mapkit.Style({
            strokeColor: color,
            fillColor: color,
            strokeOpacity: 1,
            lineWidth: 2,
            lineJoin: "round",
            lineDash: [2, 2, 6, 2, 6, 2]
        });

        let rectangle = new window.mapkit.PolygonOverlay(points, { style: style });
        map._impl.addOverlay(rectangle);
    }


    function geoCoder(address, callback) {
        const geocoder = new window.mapkit.Geocoder({
            language: "en",
            getsUserLocation: false
        });

        geocoder._impl.lookup(address, (e, r) => {
            if (r?.results.length > 0) {
                callback(r.results[0]);
            } else {
                callback(false);
            }
        });
    }

    function centerToCoordinates(lat, long, zoomLevel) {
        if (map === null || map._impl.state !== "Rendered") {
            setTimeout(() => {
                centerToCoordinates(lat, long);
            }, 500);
            return;
        }

        let coordinates = new window.mapkit.Coordinate(lat, long);
        map._impl.setCenterAnimated(coordinates, true);
        
        if (zoomLevel) {
            map._impl.zoomLevel = zoomLevel;
        }
    }

    function addAnnotationTracked(lat, long, title, callback)
    {
        if (map === null) {
            setTimeout(() => {
                addAnnotation(lat, long, title);
            }, 200);
            return;
        }

        let coordinates = new window.mapkit.Coordinate(lat, long);
        let annotation = new window.mapkit.MarkerAnnotation(coordinates, {title: title, draggable: true});
        annotation.addEventListener('drag-end', (e) => {
            callback(annotation._impl.coordinate);
        });

        map.addAnnotation(annotation);
    }

    function addAnnotation(lat, long, title, callback) {
        if (map === null) {
            setTimeout(() => {
                addAnnotation(lat, long, title);
            }, 200);
            return;
        }

        let coordinates = new window.mapkit.Coordinate(lat, long);
        let annotation = new window.mapkit.MarkerAnnotation(coordinates, {title: title});
        map.addAnnotation(annotation);

        if (callback)
        {
            callback(annotation);
        } 
    }

    function removeAnnotation(annotation) {
        try {
            map.removeAnnotation(annotation);
        } catch {
            
        }
    }

    function deleteAllAnotations() {
        if (map === null) {
            setTimeout(() => {
                deleteAllAnotations();
            }, 200);
            return;
        }

        map._impl.removeAnnotations(map._impl.annotations);
    }

    //EFFECTS
    useEffect(() => {
        let newMap;

        newMap = new window.mapkit.Map(props.id);
        setMap(newMap);

        newMap.center = new window.mapkit.Coordinate(props.lat, props.long);
        newMap._impl.zoomLevel = 13;

        if (props.setMapLoadedCallback) {
            props.setMapLoadedCallback();
        }

        const event = (e) => {
            var coordinate = newMap.convertPointOnPageToCoordinate(e.pointOnPage);
            if (props.coordinateClick)
            {
                props.coordinateClick(coordinate);
            }
        }

        newMap.addEventListener("single-tap", event);

        return () => {
            deleteAllAnotations();
            if (newMap) {
                newMap.destroy();
                newMap.removeEventListener("single-tap", event);
            }
              setMap(null);
        };
    }, [props.id]);

    return (
        <div className='apple_map_widget' style={{width: "100%", height: "100%"}} id={props.id}>
            
        </div>
    );
});
